import IconFooter from "./IconFooter";
export default IconFooter;